export default function LoadingScreen() {
    return (
        <>
            <div
                style={{
                    fontSize: "24px",
                    marginBottom: "8px",
                    fontWeight: "bold",
                }}
            >
                Loading
            </div>
            <div
                style={{
                    fontSize: "14px",
                    marginBottom: "20px",
                    textAlign: "center",
                }}
            >
                This could take up to 1 minute, please wait...
            </div>
            <div
                style={{
                    width: "50px",
                    height: "50px",
                    border: "3px solid #5a7a7a",
                    borderTop: "3px solid #6b9e9e",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                }}
            />
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </>
    );
}
